module.exports = __webpack_public_path__ + "static/media/ei09.9367da6c.png";